import { getUniqueId } from '@/editor/utils';
import { EColumnType, IColumnData } from './model';
import { globalStores } from '@/editor/stores';
import { BUILD_PROPERTIES } from '@/editor/constant/buildProperties';

export function getDefaultColumnData(type: EColumnType) {
  switch (type) {
    case EColumnType.cylinder: {
      return {
        id: getUniqueId(),
        type: EColumnType.cylinder,
        center: { x: 0, y: 0 },
        radius: BUILD_PROPERTIES.CYLINDER_COLUMN.DEFAULT_DIAMETER / 2,
        rotation: 0,
        height: globalStores.paramStore.layerHeight,
        offGround: 0
      } satisfies IColumnData;
    }
    case EColumnType.squareColumn: {
      return {
        id: getUniqueId(),
        type: EColumnType.squareColumn,
        center: { x: 0, y: 0 },
        width: BUILD_PROPERTIES.SQUARE_COLUMN.DEFAULT_LENGTH,
        thickness: BUILD_PROPERTIES.SQUARE_COLUMN.DEFAULT_WIDE,
        rotation: BUILD_PROPERTIES.SQUARE_COLUMN.DEFAULT_ROTATION_ANGLE,
        height: globalStores.paramStore.layerHeight,
        offGround: 0
      } satisfies IColumnData;
    }
  }
}
